import { PatientRecommendationsRepository, type PatientRecommendations, type RecommendationsSubject } from "../../patient";

export type { RecommendationsSubject };

/** The AI recommendations for whoever a session is with; null when they could not be read. */
export async function getRecommendations(subjectId: string, subject: RecommendationsSubject): Promise<PatientRecommendations | null> {
    return new PatientRecommendationsRepository().getRecommendations(subjectId, subject);
}
